import { render } from "./statisticsModal.vue?vue&type=template&id=4982c58d&scoped=true"
import script from "./statisticsModal.vue?vue&type=script&lang=js"
export * from "./statisticsModal.vue?vue&type=script&lang=js"

import "./statisticsModal.vue?vue&type=style&index=0&id=4982c58d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4982c58d"]])

export default __exports__